export const GET_TRAINER_SUCCEED = 'Trainer/GET_SUCCEEDED';
export const GET_TRAINER_ERROR = 'Trainer/GET_ERROR';
export const UPDATE_TRAINER_SUCCEED = 'Trainer/UPDATE_SUCCEEDED';
export const UPDATE_TRAINER_ERROR = 'Trainer/UPDATE_SUCCEEDED';
export const GET_FOCUS_ARES_SUCCESS = 'Trainer/GET_FOCUS_ARES_SUCCESS';
export const TRAINING_LOADING_STATE = 'Trainer/TRAINING_LOADING_STATE';
export const UPDATE_TRAINER_LAST_READ_NOTIFICATION_SUCCEEDED =
  'Trainer/UPDATE_LAST_READ_NOTIFICATION_SUCCEEDED';
